export default __webpack_public_path__ + "img/5cd63e8288a836b11570b24f033f8cb1.svg";